module.exports = __webpack_public_path__ + "img/e_r_logo_white.77c06246.png";